module.exports = __webpack_public_path__ + "img/bd_other06.5df64f03.png";